import React from 'react';
import { NavLink } from 'react-router-dom';

import useAppInfo from '../../../../../../common/hooks/useAppInfo';
import { setDefaultFilterItemsToStorage } from '../MenuOptionsService';

export default function Logo() {
  const appInfo = useAppInfo();
  const displayAppVersion = appInfo?.displayAppVersion;
  return (
    <NavLink onClick={setDefaultFilterItemsToStorage} className="pl-4 pr-3 mr-2 eui-link-img" to="/">
      <img alt="" className="elligo-logo-img" src={`${process.env.PUBLIC_URL}/assets/images/Elligo_logo.svg`} />
      {displayAppVersion?.includes('TRN') && <span>TRAINING</span>}
      {displayAppVersion?.includes('SND') && <span>SANDBOX</span>}
      {displayAppVersion?.includes('STAGE') && <span>STAGING</span>}
    </NavLink>
  );
}
